export default "__VITE_ASSET__Bjhr5JVj__"